import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PromoPopup.css';

import promoBanner from '../assets/promo_growatt_battery.jpg';

// Your Limited Time Offer image
import limitedOfferImage from '../assets/promo_offer.png';


export default function PromoPopup() {
  const [open, setOpen] = useState(false);


  /* ============================================================
     PROMOTION END DATE
     ============================================================ */

  const calculateTimeLeft = () => {
    const endDate = new Date(
      2026,
      8,
      30,
      23,
      59,
      59
    );

    const now = new Date();
    const difference = endDate.getTime() - now.getTime();

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        expired: true,
      };
    }

    const totalSeconds = Math.floor(difference / 1000);

    return {
      days: Math.floor(totalSeconds / 86400),

      hours: Math.floor(
        (totalSeconds % 86400) / 3600
      ),

      minutes: Math.floor(
        (totalSeconds % 3600) / 60
      ),

      seconds: totalSeconds % 60,

      expired: false,
    };
  };


  const [timeLeft, setTimeLeft] = useState(
    calculateTimeLeft()
  );


  /* ============================================================
     UPDATE COUNTDOWN
     ============================================================ */

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);


  /* ============================================================
     LOCK PAGE WHEN POPUP IS OPEN
     ============================================================ */

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);


  /* ============================================================
     ESC TO CLOSE
     ============================================================ */

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    window.addEventListener(
      'keydown',
      handleKeyDown
    );

    return () => {
      window.removeEventListener(
        'keydown',
        handleKeyDown
      );
    };
  }, [open]);


  /* ============================================================
     FORMAT NUMBER
     ============================================================ */

  const formatNumber = (number) => {
    return String(number).padStart(2, '0');
  };


  return (
    <>
      {/* ============================================================
          FLOATING LIMITED TIME OFFER
         ============================================================ */}

      {!open && !timeLeft.expired && (
        <button
          type="button"
          className="promo-fab"
          aria-label="View limited time offer"
          onClick={() => setOpen(true)}
        >

          <div className="promo-fab-content">


            {/* ================================================
                YOUR LIMITED TIME OFFER IMAGE
               ================================================ */}

            <div className="promo-fab-image-wrapper">
              <img
                src={limitedOfferImage}
                alt="Limited Time Offer"
                className="promo-fab-image"
              />
            </div>


            {/* ================================================
                FLOATING COUNTDOWN
               ================================================ */}

            <div className="promo-fab-countdown">

              <div className="promo-fab-time-item">

                <div className="promo-fab-number-box">
                  {formatNumber(timeLeft.days)}
                </div>

                <span>DAYS</span>

              </div>


              <div className="promo-fab-colon">
                :
              </div>


              <div className="promo-fab-time-item">

                <div className="promo-fab-number-box">
                  {formatNumber(timeLeft.hours)}
                </div>

                <span>HRS</span>

              </div>


              <div className="promo-fab-colon">
                :
              </div>


              <div className="promo-fab-time-item">

                <div className="promo-fab-number-box">
                  {formatNumber(timeLeft.minutes)}
                </div>

                <span>MINS</span>

              </div>


              <div className="promo-fab-colon">
                :
              </div>


              <div className="promo-fab-time-item">

                <div className="promo-fab-number-box">
                  {formatNumber(timeLeft.seconds)}
                </div>

                <span>SECS</span>

              </div>

            </div>

          </div>

        </button>
      )}


      {/* ============================================================
          POPUP OVERLAY
         ============================================================ */}

      {open && (
        <div
          className="promo-overlay"
          onClick={() => setOpen(false)}
        >

          <div
            className="promo-dialog"
            onClick={(event) =>
              event.stopPropagation()
            }
          >


            {/* ====================================================
                CLOSE BUTTON
               ==================================================== */}

            <button
              type="button"
              className="promo-close"
              aria-label="Close promotion"
              onClick={() => setOpen(false)}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 6L18 18M18 6L6 18"
                  stroke="#050b14"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>


            {/* ====================================================
                ORIGINAL POPUP COUNTDOWN
                FIRE REMOVED
               ==================================================== */}

            {!timeLeft.expired && (
              <div className="promo-countdown">

                <div className="promo-countdown-content">

                  <div className="promo-countdown-item">

                    <span className="promo-countdown-number">
                      {formatNumber(timeLeft.days)}
                    </span>

                    <span className="promo-countdown-label">
                      DAYS
                    </span>

                  </div>


                  <span className="promo-countdown-divider">
                    /
                  </span>


                  <div className="promo-countdown-item">

                    <span className="promo-countdown-number">
                      {formatNumber(timeLeft.hours)}
                    </span>

                    <span className="promo-countdown-label">
                      HOURS
                    </span>

                  </div>


                  <span className="promo-countdown-divider">
                    /
                  </span>


                  <div className="promo-countdown-item">

                    <span className="promo-countdown-number">
                      {formatNumber(timeLeft.minutes)}
                    </span>

                    <span className="promo-countdown-label">
                      MINUTES
                    </span>

                  </div>


                  <span className="promo-countdown-divider">
                    /
                  </span>


                  <div className="promo-countdown-item">

                    <span className="promo-countdown-number">
                      {formatNumber(timeLeft.seconds)}
                    </span>

                    <span className="promo-countdown-label">
                      SECONDS
                    </span>

                  </div>

                </div>

              </div>
            )}


            {/* ====================================================
                PROMOTION IMAGE
               ==================================================== */}

            <Link
              to="/contact"
              className="promo-card"
              onClick={() => setOpen(false)}
            >

              <img
                src={promoBanner}
                alt="Growatt limited time offer"
                className="promo-card-img"
              />

            </Link>

          </div>

        </div>
      )}

    </>
  );
}